<div class="k-container">
	<div class="k-row">
		<ng-container *ngIf="questionData.showQuestionImage; else noImage">
			<div
				class="k-col k-col-md-4 k-col-sm-12"
				style="text-align: left">
				<a
					*ngIf="!questionData.notAllowLightbox"
					data-gallery="photoQuestion"
					data-toggle="lightbox"
					data-type="image"
					data-title="Question Image"
					href="#"
					[attr.data-remote]="questionData.imageUrl"
					(click)="onImageClick($event)">
					<img
						class="k-image"
						[src]="questionData.imageUrl"
						style="width: 100px; height: 100px" />
				</a>
				<img
					*ngIf="questionData.notAllowLightbox"
					class="k-image"
					[src]="questionData.imageUrl"
					style="width: 100px; height: 100px" />
			</div>
		</ng-container>
		<ng-template #noImage></ng-template>
		<div class="k-col k-col-md-8 k-col-sm-12">
			<div style="font-weight: bold; text-align: left">Question #{{ questionData.orderNumber }}:</div>
			<div style="font-weight: bold; text-align: left">
				{{ questionData.questionText }}
			</div>
			<div
				class="k-mt-2"
				style="text-align: left">
				<span [innerHTML]="questionData.questionDescription"></span>
			</div>
			<div
				class="k-mt-2"
				style="text-align: left"
				*ngIf="questionData.showReferenceUrl">
				<label class="k-label">
					Reference URL:
					<a
						[href]="questionData.referenceUrl"
						target="_blank"
						>{{ questionData.referenceUrl }}</a
					>
				</label>
			</div>
		</div>
	</div>

	<div
		class="k-mt-3"
		*ngIf="questionData.shortResponse">
		<div style="font-weight: bold; text-align: left">Response:<br /></div>
		<kendo-textarea
			[(ngModel)]="questionData.responseText"
			rows="4"
			style="resize: none"></kendo-textarea>
	</div>
	<ng-container *ngIf="questionData.multipleChoice">
		<div style="text-align: left">
			<div
				*ngFor="let choice of questionData.responses"
				class="k-mt-3">
				<p>
					<input
						name="QuestionRadioButtons{{ questionData.orderNumber }}"
						type="radio"
						kendoRadioButton
						[value]="choice.id"
						#{{choice.id}}
						[(ngModel)]="questionData.selectedResponseId" />
					<kendo-label
						class="k-radio-label"
						for="{{ choice.id }}"
						text="{{ choice.responseText }}"></kendo-label>
				</p>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="questionData.multipleAnswer">
		<div style="text-align: left">
			<div
				*ngFor="let response of questionData.responses; let i = index"
				class="k-mt-3">
				<p>
					<kendo-checkbox
						[(ngModel)]="questionData.responseCheckItems[i].checked"
						id="QuestionCheckBox{{ response.Id }}"></kendo-checkbox>

					<label
						for="QuestionCheckBox{{ response.Id }}"
						style="display: inline; font-weight: normal">
						{{ response.responseText }}
					</label>
				</p>
			</div>
		</div>
	</ng-container>
	<div
		class="k-mt-3"
		*ngIf="!questionData.notAllowComments">
		<div style="font-weight: bold; text-align: left">Comments:<br /></div>
		<kendo-textarea
			[(ngModel)]="questionData.comments"
			rows="4"
			style="resize: none"></kendo-textarea>
	</div>
</div>
